import { filter, flatMap } from 'rxjs/operators';
import { of, concat } from 'rxjs';
import { ofType } from 'redux-observable';
import { selectors as marketSelectors } from '@clearscore/redux.market';
import {
    actions as profileActions,
    types as profileTypes,
    selectors as profileSelectors,
} from '@clearscore/redux.profile';
import { actions as alertActions, constants as alertConstants } from '@clearscore/redux.alerts';
import { IN } from '@clearscore/config.i18n';
import Text from '@clearscore/rainbow.text';
import interpolateWithComponents from '@clearscore/helpers.interpolate-with-components';
import getEnv from '@clearscore/helpers.envs';

import lang from '../lang';

const TNC_DOC_KEY = 'tnc';

const getLatestTnc = (state) => {
    const { documentsMeta = [] } = profileSelectors.getDocumentsMeta(state);
    return documentsMeta.find((doc) => doc.docType === TNC_DOC_KEY) || {};
};

const newState = (state$, payload) => ({
    ...state$.value,
    profile: {
        ...state$.value.profile,
        ...payload,
    },
});

const termsAndConditionsEpic = (action$, state$) => {
    const isTermsUpdated = ({ payload }) => {
        const state = newState(state$, payload);
        const market = marketSelectors.getActiveMarket(state);
        const { tncAgreedVersion } = profileSelectors.getTerms(state);
        const { version = 0 } = getLatestTnc(state);
        return market === IN && version && tncAgreedVersion < version;
    };

    const handleTermsAlert = ({ payload }) => {
        const state = newState(state$, payload);
        const { version } = getLatestTnc(state);
        return concat(
            of(profileActions.save({ tncAgreedVersion: version })),
            of(
                alertActions.showAlert({
                    alertContent: interpolateWithComponents(lang.termsUpdated, [
                        {
                            Component: Text.Link,
                            props: {
                                key: 'terms-link',
                                href: getEnv('IN_TERMS_URL'),
                                isNewTab: true,
                            },
                        },
                    ]),
                    alertType: alertConstants.DEFAULT,
                    isDismissible: true,
                    sticky: true,
                }),
            ),
        );
    };

    return action$.pipe(ofType(profileTypes.PROFILE_FETCH_SUCCESS), filter(isTermsUpdated), flatMap(handleTermsAlert));
};

export default termsAndConditionsEpic;
